
export default function homeWidgetDelete(way, id) {

    this.confrim("Do you really want to delete this widget?", () => {
      this.dataDelete(way, id);
      this.popupHide();
      this.homeLayoutSave();
    });
}